import { useState } from 'react'
import { Box, Image, Text } from '@chakra-ui/react'
import { Swiper, SwiperSlide } from 'swiper/react'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/thumbs'

import { Navigation, Pagination, Thumbs, Autoplay } from 'swiper/modules'

export function ImageSlider({ images, alt = 'Imagem do produto' }) {
  const [thumbsSwiper, setThumbsSwiper] = useState(null)

  if (!images || images.length === 0) {
    return (
      <Box height="200px" display="flex" alignItems="center" justifyContent="center" bg="gray.100" borderRadius="md">
        <Text color="gray.500">Nenhuma imagem disponível</Text>
      </Box>
    )
  }

  return (
    <Box>
      {/* Slide principal */}
      <Box mb={2} height="200px">
        <Swiper
          modules={[Navigation, Pagination, Thumbs, Autoplay]}
          spaceBetween={10}
          slidesPerView={1}
          navigation={true}
          pagination={{ clickable: true }}
          thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          className="produto-swiper"
        >
          {images.map((imgUrl, imgIndex) => (
            <SwiperSlide key={imgIndex}>
              <Box
                height="200px"
                width="100%"
                position="relative"
                borderRadius="md"
                overflow="hidden"
                bg="white"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Image
                  src={imgUrl}
                  alt={`${alt} - imagem ${imgIndex + 1}`}
                  maxHeight="200px"
                  maxWidth="100%"
                  objectFit="contain"
                  fallbackSrc="https://via.placeholder.com/300?text=Imagem+não+disponível"
                />
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>

      {/* Miniaturas apenas se tiver mais de 1 imagem */}
      {images.length > 1 && (
        <Box height="60px">
          <Swiper
            modules={[Navigation, Thumbs]}
            onSwiper={setThumbsSwiper}
            spaceBetween={5}
            slidesPerView={4}
            watchSlidesProgress={true}
            className="thumbnail-swiper"
          >
            {images.map((imgUrl, imgIndex) => (
              <SwiperSlide key={imgIndex}>
                <Box
                  height="60px"
                  width="100%"
                  position="relative"
                  borderRadius="md"
                  overflow="hidden"
                  borderWidth="1px"
                  borderColor="gray.200"
                  cursor="pointer"
                  _hover={{
                    borderColor: 'blue.500',
                    transform: 'scale(1.05)',
                    transition: 'all 0.2s',
                  }}
                >
                  <Image
                    src={imgUrl}
                    alt={`${alt} - miniatura ${imgIndex + 1}`}
                    width="100%"
                    height="100%"
                    objectFit="cover"
                    fallbackSrc="https://via.placeholder.com/60?text=Imagem+não+disponível"
                  />
                </Box>
              </SwiperSlide>
            ))}
          </Swiper>
        </Box>
      )}
    </Box>
  )
}
